import { getProfile } from './profile'
import { getUserVehicles } from './vehicles'

export const userApi = {
  getProfile,
  getUserVehicles
}